const MASKED_SERVER_ERROR = 'Something went wrong.'
const SCHEMA_ERROR_PREFIX = 'Variable "'

export const userFacingMutationError = (
  error: { graphQLErrors?: { message?: string }[] } | undefined,
  fallback: string
): string => {
  const message = error?.graphQLErrors?.[0]?.message?.trim()
  if (
    !message ||
    message === MASKED_SERVER_ERROR ||
    message.startsWith(SCHEMA_ERROR_PREFIX)
  ) {
    return fallback
  }
  return message
}
